// ISO_4217: unicode // symbol
// http://www.unicode.org/charts/PDF/U20A0.pdf

'use strict';

module.exports = {
  'AFN': '؋', // ؋
  'AMD': '֏', // ֏
  'ANG': 'ƒ', // ƒ
  'AWG': 'ƒ', // ƒ
  'AZN': '₼', // ₼
  'BDT': '৳', // ৳
  'BTC': 'Ƀ', // Ƀ
  'CNY': '¥', // ¥
  'CRC': '₡', // ₡
  'EUR': '€', // €
  'FKP': '£', // £
  'GBP': '£', // £
  'GHS': '₵', // ₵
  'GIP': '£', // £
  'ILS': '₪', // ₪
  'INR': '₹', // ₹
  'IRR': '﷼', // ﷼
  'JPY': '¥', // ¥
  'KHR': '៛', // ៛
  'KPW': '₩', // ₩
  'KRW': '₩', // ₩
  'KZT': '₸', // ₸
  'LAK': '₭', // ₭
  'LKR': '₨', // ₨
  'MNT': '₮', // ₮
  'MTL': '₤', // ₤
  'MUR': '₨', // ₨
  'NGN': '₦', // ₦
  'NPR': '₨', // ₨
  'OMR': '﷼', // ﷼
  'PHP': '₱', // ₱
  'PKR': '₨', // ₨
  'PYG': '₲', // ₲
  'QAR': '﷼', // ﷼
  'RUB': '₽', // ₽
  'SAR': '﷼', // ﷼
  'SCR': '₨', // ₨
  'SDG': '£', // £
  'SHP': '£', // £
  'SVC': '₡', // ₡
  'SYP': '£', // £
  'THB': '฿', // ฿
  'UAH': '₴', // ₴
  'USD': '$', // $
  'VND': '₫', // ₫
  'YER': '﷼' // ﷼
};

